<template>
  <div v-if="items?.length" class="def-ai-buttons">
    <span class="def-ai-buttons__title">{{ title }}</span>

    <div class="def-ai-buttons-items">
      <a
        v-for="({ link, code }, i) in items"
        :key="i"
        :href="link"
        target="_blank"
        class="def-ai-button"
      >
        <svg class="def-ai-button__icon">
          <use :xlink:href="`#svg-${code}`"></use>
        </svg>
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  items?: Array<{
    code: string;
    link: string;
  }>;
  title: string;
}>();
</script>

<style lang="scss" scoped>
.def-ai-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  &__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
  }
}
.def-ai-buttons-items {
  display: inline-grid;
  grid-auto-flow: column;
  grid-column-gap: 24px;
  align-items: center;
}
.def-ai-button {
  display: inline-block;
  width: 24px;
  height: 24px;
  &__icon {
    width: 24px;
    height: 24px;
  }
}
</style>
